import { consola } from "consola";
const logLevel = process.env.NUXT_PUBLIC_LOG_LEVEL;
const consolaLevel = {
  trace: 5,
  debug: 4,
  info: 2,
  warn: 1,
  error: 0,
  silent: -999,
  verbose: 999
};
export const logger = consola;
export function useRhythmicLogger(tag, options = {}) {
  const optionsPlus = {
    level: consolaLevel[logLevel] ?? 5,
    ...options
  };
  const baseLogger = tag ? logger.create(optionsPlus).withTag(tag) : logger;
  return baseLogger;
}
